// extracted by mini-css-extract-plugin
export default {"light":"#e9e9e9","dark":"#084e95","primary":"#1daedf","secondary":"#00d9ca","info":"#f87b86","success":"#3ebc70","warning":"#edd037","danger":"#f9252c","gray":"#333"};